import { createApi } from '@/api'
export default {
  hotelList: config => createApi(`/hotel/pageSearch`, 'post', config), // 酒店列表
  hotelDetail: config => createApi(`/hotel/get`, 'get', config), // 酒店详情
  addhotel: config => createApi(`/hotel/add`, 'post', config), // 酒店添加
  deletehotel: config => createApi(`/hotel/delete`, 'delete', config), // 酒店删除
  updatehotel: config => createApi(`/hotel/update`, 'post', config) // 酒店修改
}



// WEBPACK FOOTER //
// ./src/views/hotelManage/api/index.js